import { snakeToCamelCaseKeys } from 'services/helpers';
import {
  AutomationVariableDataType,
  DeletedOption,
} from 'pages/AutomationEngine/types';
import { GenericOption } from 'pages/AutomationEngine/types';
import { useActivityQuery } from '__queries/models/activities-ts';

import { FieldLike, VisibilityRule } from 'ts-activities/types';

type ActivityLike = {
  id: string;
  fields: FieldLike[];
  visibilityRules: VisibilityRule[];
};

export const useActivityObjectOptions = (
  valueCategory: GenericOption | undefined,
  dataType: AutomationVariableDataType | undefined,
  dataSubtype: DeletedOption | undefined
) => {
  const {
    data: activityObjectOptions,
    isLoading: loadingActivityObjectOptions,
  } = useActivityQuery<ActivityLike>((valueCategory as GenericOption)?.value!, {
    select: (res) => {
      let customObjects = res.custom_objects
        .map(({ object_name, id }) => ({
          value: id,
          label: object_name,
          entityId: id,
        }))
        .sort((a, b) => a.label.localeCompare(b.label));

      customObjects = [...new Set(customObjects)];
      // if entity on return options that belong
      if (dataType === 'entity') {
        customObjects = customObjects.filter(
          ({ entityId }) => entityId && entityId === dataSubtype?.value
        );
      }

      return snakeToCamelCaseKeys(customObjects);
    },
    enabled: !!(valueCategory as GenericOption)?.value,
    throwOnError: false,
    retry: false,
  });
  return { activityObjectOptions, loadingActivityObjectOptions };
};
